<template>
  <div>
    <div class="box">
      <p class="return" @click='$router.go(-1)'>返回</p>
      <span class="line">|</span>
      <p class="contract back"  @click="backTo">项目列表</p>
      <span class="lines">></span>
      <p class="contract back" @click="$router.go(-1)">关联设置</p>
      <span class="lines">></span>
      <p class="contract">已交付候选人</p>
    </div>
    <div class="sign adaptation" style="padding: 0">
      <div class="tab_nav">
        <div class="tab_search">
          <div>
            <span class="checkedss"> 已交付候选人- {{this.$route.query.name}}</span>
          </div>
        </div>
      </div>
      <div class="titlecontent">
        <div class="center">
          <div class="titlemessage">
            <div class="title">
              <span>RPO执行公司：</span>
              <span>{{list.rpoImplementCompany}}</span>
            </div>
            <div class="title">
              <span>需求方：</span>
              <span>{{list.employer}}</span>
            </div>
          </div>
          <div class="titlemessage">
            <div class="title">
              <span>RPO项目经理：</span>
              <span>{{list.rpoManager}}</span>
            </div>
            <div class="title">
              <span>申请时间：</span>
              <span>{{list.creatTime}}</span>
            </div>
            <div class="title">
              <span>同意申请时间：</span>
              <span>{{list.processTime}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="buttonbtn">
        <button type="button" class="btn subbtn" @click="exp"> 导出已交付候选人 </button>
      </div>
      <div class="table">
        <el-table
          ref="table"
          :default-sort="{ prop: 'date', order: 'descending' }"
          :data="contentList"
          :header-cell-style="{ color: '#303140' }"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            class="firstone"
            prop="name"
            label="姓名"
            min-width="100"
            align="left"
          >
            <template slot-scope="scope">
               <span v-if="scope.row.state == 1 || scope.row.state == 5">{{ scope.row.name }}</span>

              <span v-else 
                style="color: #6669e3; cursor: pointer"
                @click.stop="handle(scope.row)"
                >{{ scope.row.name }}</span
              >
            </template>
          </el-table-column>

          <el-table-column prop="sex" label="性别" min-width="70" align="left">
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            min-width="100"
            align="left"
          >
          </el-table-column>

          <el-table-column
            prop="rpoPositionName"
            label="RPO职位"
            min-width="100"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="dateReleased"
            label="交付日期"
            min-width="110"
            align="left"
          >
           
          </el-table-column>
          <el-table-column
            prop="startDate"
            label="入职日期"
            min-width="110"
            align="left"
          >
         
          </el-table-column>
          <el-table-column
            prop="leavejobDate"
            label="离职日期"
            min-width="110"
            align="left"
          >
           
          </el-table-column>
          <el-table-column
            label="状态"
            min-width="90"
            align="left"
          >
            <template slot-scope="scope">
              <span class="status1"  v-if="scope.row.state == 2">待入职</span>
              <span class="status2"  v-if="scope.row.state == 4">离职</span>
              <span  v-if="scope.row.state == 1" span class="status2">未入职</span>
              <span v-if="scope.row.state == 3" class="status3">在职</span>
              <span class="status2"  v-if="scope.row.state == 5">拒收</span> 
            </template>
          </el-table-column>
          <div>
            <el-table-column class="expandsa" type="expand" width="1">
              <template slot-scope="scope">
                <div
                  class="content"
                  style="height:95px"
                >
                  <el-steps direction="vertical" v-for="(v, k) in detaileList"  :key="k"
                     >
                    <el-step 
                      :description="v.createTime"
                       :icon=" 'el-lic'" :active="0"
                     
                    >
                      <span slot="title" >离职</span>
                      <span v-if="v.leavejobDate" slot="description" >{{ v.leavejobDate }}</span>
                      <span  v-if="!v.leavejobDate" slot="description" >--</span>

                      <span slot="description" style="margin-left: 40px"
                        >操作人：<span v-if="v.leavejobDate">{{v.leavejobOperator}}</span> <span v-if="!v.leavejobDate">--</span></span
                      >
                    </el-step>
                    <el-step
                      
                      :description="v.createTime"
                       :icon=" 'el-li'" :active="1"
                    >
                      <span slot="title" >入职</span>
                      <span v-if="v.startDate" slot="description" >{{ v.startDate }}</span>
                      <span  v-if="!v.startDate" slot="description" >--</span>

                      <span slot="description" style="margin-left: 40px"
                        >操作人：<span v-if="!v.startDate">--</span><span v-if="v.startDate">{{v.startOperator}}</span></span
                      >
                    </el-step>
                    <el-step
                      
                      :description="v.createTime"
                       :icon=" 'el-li'" :active="2"
                      
                    >
                      <span slot="title" >待入职</span>
                      <span v-if="v.waitDate" slot="description" >{{ v.waitDate }}</span>
                      <span  v-if="!v.waitDate" slot="description" >--</span>

                      <span slot="description" style="margin-left: 40px"
                        >操作人：<span v-if="v.waitDate">{{v.waitOperator}}</span><span v-if="!v.waitDate">--</span></span
                      >
                    </el-step>
                   

                  </el-steps>
                </div>
              </template>
            </el-table-column>
          </div>
        </el-table>
        <page
          :pagesize="pageSize"
          :total="total"
          v-show="total > 0"
          @currentChange="cur"
          @enter="cur"
          ref="page"
        ></page>
      </div>
    </div>
    
  </div>
</template>
<script>
export default {
  created() {
    this.maskshow = this.$route.params.maskshow;
    this.masktype = this.$route.params.masktype;
    this.totals = this.$route.params.totals;
    this.noconnect = this.$route.params.noconnect;
    this.yesORno = this.$route.params.yesORno;
    this.loadData();
    this.getBatchTaskExecuteInfo();
    this.$once("hook:beforeDestroy", () => {
      clearTimeout(this.timeout);
    });
  },
  mounted() {
    this.btnPermissionsStr = sessionStorage.getItem("btnPermissions");
    window.addEventListener('hashchange', function(e) {

}, false);
    // this.$nextTick(() => {
    //   if (this.yesORno) {
    //     (this.maskshow = true),
    //       (this.masktype = "pushFile"),
    //       (this.totals = this.$route.params.totals),
    //       (this.noconnect = this.$route.params.noconnect);
    //   }
    // });
  },
  data() {
    return {
      detaileList:[],
      contentList: [],
      rules: {
        messger: [
          {
            required: true,
            message: "请选择项目经理",
            trigger: "change",
          },
        ],
        payrollSubject: [
          {
            required: true,
            message: "请选择发新主体",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入您的项目名称",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/,
            message: "不能输入空格",
          },
        ],
        projectID: [
          {
            required: true,
            message: "请输入您的项目标识",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/,
            message: "不能输入空格",
          },
        ],
        isMust: [
          {
            required: true,
            message: "请输入您的项目编号",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/,
            message: "不能输入空格",
          },
        ],
      },
      addForm: {
        name: "",
        isMust: "",
        ssgProjectCode: this.$route.query.code,
        messger: "",
        payrollSubject: "",
        projectID: "",
      },
      payList: [],
      btnPermissionsStr: {},
      radio: 1,
      yesORno: false,
      list: {},
      tasknumber: 0,
      taskList: [{}],
      badgeHidden: true,
      maskshow: false,
      masktype: "",
      pushEmployTotal: 0,
      noconnect: 0,
      type: 2,
      noticeStatus: 1,
      pageNo: 1,
      pageSize: 10,
      id: "",
      total: 0,
      form: {
        name: "",
        userName: "",
        status: "",
      },
    };
  },
  watch: {
    // pageNo: function (val, oldVal) {
    //   this.$refs.page.page = val;
    // },
    
  },
  
  created() {
    this.loadData();
    this.load();
    // this.yesORno = this.$route.params.yesORno;

  },
  
  methods: {
    
      //导出已交付候选人
    exp() {
      this.$confirm("下载到本地, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: 'warning'
        iconClass: "el-icon-caveat",
      })
        .then(() => {
          var param = "projectId=" + this.$route.query.projectId+'&rpoId='+this.$route.query.rpoId+'&rpoProjectName='+this.$route.query.name
          this.$axios
            .get("rpoProjectRelvance/exportRpoProjectEmploy?projectId="+this.$route.query.projectId+'&rpoId='+this.$route.query.rpoId, {
              responseType: "blob",
            })
            .then((res) => {
              let blob = res.data;
              let a = document.createElement("a");
              let headers = res.headers;
              let fileName = headers["content-disposition"];
              a.download =  "已交付候选人.xlsx";
              a.href = URL.createObjectURL(blob);
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //点击显示当前详情
    tableRowClassName({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },
    handle(row, event, column) {
      this.detaileList = []
      let id = row.id;
      let index = row.index;
      this.status = row.status;
      let $table = this.$refs.table;
      this.contentList.map((item) => {
        if (row.id != item.id) {
          $table.toggleRowExpansion(item, false);
        }
      });
      $table.toggleRowExpansion(row);
      this.$axios
        .get("/rpoProjectRelvance/QueryRpoEmployParticulars?id=" + id)
        .then((res) => {
          this.detaileList.push({
            waitDate:res.data.data.waitDate,
            waitOperator:res.data.data.waitOperator,
            startDate:res.data.data.startDate,
            startOperator:res.data.data.startOperator,
            leavejobDate:res.data.data.leavejobDate,
            leavejobOperator:res.data.data.leavejobOperator
            
          })
        
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    load() {
      var params = {};
     
      this.$axios
        .get("rpoProjectRelvance/QueryRpoProjectEmploy?rpoId="+this.$route.query.rpoId+'&projectId='+this.$route.query.projectId+'&pageNum='+this.pageNo+'&pageSize='+this.pageSize,)
        .then((res) => {
          if (res.data.status == 1) {
            this.contentList = res.data.data.list;
          this.total = res.data.data.total;

          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    fontpayrollSubject() {
      var params = {};
      this.$axiosempo
        .get("payroll/getPayrollSubjectList", { params })
        .then((res) => {
          if (res.data.status == 1) {
            this.payList = res.data.data;

          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },


    back() {
      this.$router.push({ path: "/main" });
    },
     backTo() {
      this.$router.push({
         path: "/ssgSplat"
         
         });
    },
    loadData() {
      const params = {
        id: this.$route.query.id,
        
      };
      return this.$axios
        .get("/rpoProjectRelvance/queryRpoProjectByid", {
          params,
        })
        .then((res) => {
          this.list = res.data.data;
          // this.total = res.data.data.total;
          this.$root.$emit("callbackdot", res.data.data.newRequestNum);

          //   if( this.pageNo!==1 && this.list.length==0){
          //     this.pageNo = this.pageNo-1
          //     this.loadData()
          //   }
          // this.noticeStatus = res.data.data.noticeStatus -1;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    ontab(v) {
      this.type = v;
      this.loadData();
    },
 
   
    
    cur(val) {
      this.pageNo = val;
      this.load();
    },
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../../assets/css/common/card.less" scoped lang="less"></style>
<style scoped lang="less">

.box {
  display: flex;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  .logo {
    margin-left: 30px;
  }
}
.top {
  padding: 30px 0 0 0;
  .notice {
    color: #303140;
    font-weight: bold;
    font-size: 20px;
  }
  .notices {
    color: #303140;
    font-weight: bold;
    span {
      color: #6669e3;
      margin-left: 10px;
    }
  }
}
.sign {
  width: 100%;
  height: 100%;
  padding: 0 50px;
  box-sizing: border-box;

  /*background-color: #fff;
          border: 1px solid #d9dbe2;
          border-radius: 6px 6px 0 0;*/
  .operating {
    width: 100%;
    min-height: 62px;
    line-height: 62px;
    box-sizing: border-box;

    .search {
      margin-right: 14px;
    }
  }

  .table {
    width: 100%;

    .tab {
      width: 100%;
      height: 98px;
      display: flex;
      align-items: center;
      border: 1px solid #d9dbe2;
      border-radius: 12px;
      margin-bottom: 15px;
      padding: 14px 0;
      box-sizing: border-box;

      .name {
        width: 80%;
        height: 100%;
        display: flex;
        // flex-direction: column;
        // justify-content: center;
        vertical-align: middle;
        text-align: center;
        padding-left: 25px;
        font-size: 16px;
        color: #6669e3;
        border-right: 1px solid #f2f5f8;
      }
      .names {
        width: 20%;
        text-align: center;
      }
      .status {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: inherit;
        font-size: 12px;
        color: #9393a2;
      }

      .three {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 12px;

        p:first-child {
          color: #9393a2;
        }

        p:last-child {
          color: #545566;
        }
      }

      .axis {
        width: 40%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .bgnull {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .bg {
        width: 214px;
        height: 110px;
        background-image: url(../../../assets/img/10wvB0eE.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 214px 110px;
        margin-top: 100px;
      }
    }
  }
}

.pbg {
  width: 75px;
  display: flex;
  justify-content: center;

  i {
    font-size: 54px;
    color: #3bc798;
  }
}

.part {
  font-size: 18px;
  margin-left: 10px;

  p {
    margin: 5px 0;

    .red {
      color: #ff6752;
    }

    .green {
      color: #3bc798;
    }
  }
}
.submess {
  .form {
    display: flex;
    /*justify-content: space-around;*/
    .img {
      background-image: url("../../../assets/img/warning.png");
      background-repeat: no-repeat;
      width: 50px;
      height: 50px;
    }
    .linhin {
      margin-left: 30px;
      height: 100px;
      line-height: 30px;
      .p1 {
        font-size: 14px;
        color: #303140;
        font-weight: bold;
      }
      .p2 {
        color: #303140;
      }
      .rad {
        color: #303140;
        .no {
          display: block;
          margin-left: 90px;
        }
      }
    }
  }
}
.filter {
  width: 100%;
  height: 57px;
  background: rgba(242, 245, 248, 1);
  border-radius: 4px;
  margin-bottom: 30px;
  .content {
    display: flex;
  }
  size {
    font-size: 12px;
    font-weight: 400;
    color: rgba(84, 85, 102, 1);
    margin-left: 10px;
    margin-right: 10px;
  }
}
.opera {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #6669e3;
  span {
    margin: 0 5px;
    color: #6669e3;

    cursor: pointer;
  }
}
.span_bgc {
  padding: 3px 5px;
  background: rgba(254, 240, 240, 1);
  border-radius: 4px;
  border: 1px solid rgba(252, 210, 210, 1);
  font-size: 12px;
  font-weight: 400;
  width: 50px;
  color: rgba(245, 116, 116, 1);
}

.span_bgc4 {
  padding: 3px 5px;
  background: rgba(234, 255, 248, 1);
  font-size: 12px;
  font-weight: 400;
  color: rgba(59, 199, 152, 1);
  border-radius: 4px;
  width: 50px;
  border: 1px solid rgba(183, 225, 211, 1);
}
.checkedss {
  width: 192px;
  height: 37px;
  font-size: 24px;
  font-weight: bold;
  color: #303140;
  line-height: 36px;
}
.newsplay {
  width: 48px;
  height: 22px;
  background: #ff6752;
  border-radius: 0px 4px 4px 0px;
  line-height: 22px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
.el-icon-question:before {
  content: "\e7a4";
  position: absolute;
  padding-left: 10px;
  margin: -10px auto;
}

.title {
  font-size: 6px;
  font-weight: 400;
  color: #545566;
}
.table /deep/ .el-table__expand-icon {
  display: none;
}
.titlecontent {
  width: 100%;
  height: 67px;
  background: #f2f3f8;
  border-radius: 4px;
  margin: 0 0 20px 0;
  .center {
    padding: 15px;
  }
  .titlemessage {
    width: 100%;
    display: flex;
    display: -moz-box;  /* Firefox */
    display: -ms-flexbox;    /* IE10 */
    display: -webkit-box;    /* Safari */ 
    display: -webkit-flex;    /* Chrome, WebKit */
    .title {
      width: 30%;
    }
  }
}
.tab_nav[data-v-67695412] {
  width: 100%;
  height: 92px;
  border-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.buttonbtn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.el-table /deep/ th > .cell {
  padding-left: 16px !important;
}
.content {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  background: #f7f8fc;

  .el-step /deep/ .el-step__icon {
    width: 7px;
    height: 7px;
    background: #f7f8fc;
    width: 24px;
  }
  .el-step.is-vertical /deep/ .el-step__main {
    padding-left: 10px;
    display: flex;
    align-items: baseline;
  }
  .el-step.is-vertical /deep/ .el-step__icon.is-icon {
    width: 24px;
}
  .el-step.is-vertical /deep/ .el-step__title {
    line-height: 24px;
    padding-bottom: 8px;
    font-size: 12px;
    font-weight: bold;
     color: #303140;
    
  }
  .el-step /deep/ .el-step__description {
    color: #8a8a9a;
    font-size: 12px;
    font-weight: 400;
    margin-left: 20px;
    width: 400px;
  }
  .el-step /deep/ .el-step__line {
    top: 14px;
    bottom: -14px;
    width: 1px;
    left: 11.5px;
  }
  .el-step.is-vertical /deep/ .el-step__head {
    flex-grow: 0;
    width: 24px;
    /* line-height: 94px; */
    margin-top: 4px;
  }

  .options {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    i {
      /*margin-left: 10px;*/
      color: #8a8a9a;
      min-width: 100px;
    }

    li {
      height: 60px;
      font-size: 14px;
      margin-top: 4px;

      span {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }

    li:last-child {
      height: auto;
      /*position: relative;
				bottom: -20px;*/
    }

    li:first-child {
      span {
        color: #000;
        font-weight: bolder;
      }
    }
  }
}
.el-table /deep/ .el-table__expanded-cell[class*="cell"] {
  padding: 15px;
  // background: #F7F8FC;
}

.status1 {
  padding: 3px 5px;
  background: #fffdec;
  border-radius: 4px;
  border: 1px solid #e7d8a0;
  color: #e7b802;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
}
.status2 {
  padding: 3px 5px;
  background: #fef0f0;
  border-radius: 4px;
  border: 1px solid #fcd2d2;
  color: #f57474;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
}
.status3 {
  padding: 3px 5px;
  background: #eafff8;
  border-radius: 4px;
  border: 1px solid #b7e1d3;
  color: #3bc798;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
}
</style>
